import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, packageExports, packageName, } = linkedPackage('lincd-server');
//# sourceMappingURL=package.js.map